import React, { useState, useEffect } from "react";
import StockDetailTable from "src/components/table/StockDetailTable";
import { getStock } from "src/api/MessageApi";
import TableTitle from "src/components/home/TableTitle";
import MoreButton2 from "src/components/button/MoreButton2";
import { ListParam, defaultListParam } from "src/types/api/listParam";

import { useSelector } from "react-redux";
import { RootState } from "src/store/store";

interface StockHomeContainerProps {
  isu_srt_cd: string;
  rowPerPage: number;
}

const StockHomeContainer: React.FC<StockHomeContainerProps> = ({ isu_srt_cd, rowPerPage }) => {
  const [stockDetail, setStockDetail] = useState([]);
  const [curPage, setCurPage] = useState(null);
  const [isMore, setIsMore] = useState(true);
  const isu_kor_abbrv = useSelector((state: RootState) => state.session.stockName);
  const defaultParams = defaultListParam();

  const fetchData = async (params: ListParam) => {
    try{
      let response;
      response = await getStock(params);
  
      const newData = response?.data?.list || [];
      if ( newData.length < rowPerPage ){
        setIsMore(false)
      } else {
        setIsMore(true)
      }
      if (params.curPage === 1) {
        setStockDetail(newData);
      } else {
        setStockDetail((prevData) => [...prevData, ...newData]); 
      }
    } catch (error) {
        console.error("API 호출 실패:", error);
        if (params.curPage === 1) setStockDetail([]);
    }
  };
  
  useEffect(() => { 
      setCurPage(null);
      defaultParams.isu_srt_cd = isu_srt_cd;
      defaultParams.rowPerPage = rowPerPage;
      fetchData(defaultParams);
  }, [isu_srt_cd, rowPerPage]);

  const handleLoadMore = async () => {
    try {
      const newPage = curPage === null ? 2 : curPage + 1;
      defaultParams.isu_srt_cd = isu_srt_cd;
      defaultParams.rowPerPage = rowPerPage;
      defaultParams.curPage = newPage;
      await fetchData(defaultParams);
      setCurPage(newPage);
    } catch (error) {
        console.error("추가 데이터 로드 실패:", error);
    }
  };

  return (
      <div className="w-100 px-3 py-4 col-12 col-lg">
          <TableTitle name={isu_kor_abbrv} />
          {/* <Chart /> */}
          <StockDetailTable contents={stockDetail} />
          {isMore && <MoreButton2 onClick={handleLoadMore} />}
      </div>
  );
};

export default StockHomeContainer;
